import { createReducer, on } from "@ngrx/store";
import { PlantCode } from "src/model/class/general classes/plant-code";
import { PlantCodeABB } from "src/model/class/general classes/plant-code-abb";
import { PlantCodeGeneric } from "src/model/class/general classes/plant-code-generic";
import {
  plantCodeAddressValueChangeAction,
  plantCodesLoadSuccessAction,
  plantCodesUnsetKeyStorage,
} from "../actions/plant-code.action";

const initialState = null;

export const PlantCodesReducer = createReducer(
  initialState,
  on(plantCodesUnsetKeyStorage, (fullPlantCodesObject: PlantCode, action) => {
    return initialState;
  }),

  on(plantCodesLoadSuccessAction, (fullPlantCodesObject: PlantCode, action) => {
    return action.plantCodesObject;
  }),
  on(
    plantCodeAddressValueChangeAction,
    (fullPlantCodesObject: PlantCode, action) => {


      const plantCodesGenericCP = [...fullPlantCodesObject.plantCodeGeneric];

      const listPlantCodeGeneric: Array<PlantCodeGeneric> = plantCodesGenericCP.map(
        (plantCodeGeneric: PlantCodeGeneric) => {
          if (
            plantCodeGeneric.instanceGUID === action.instanceGUID &&
            plantCodeGeneric.plantCodeAddress === action.address
          ) {
            plantCodeGeneric = {
              ...plantCodeGeneric,
              plantCode: action.plantCodeValue,
            };
          }

          return plantCodeGeneric;
        }
      );

      return {
        plantCodeABB: fullPlantCodesObject.plantCodeABB,
        plantCodeGeneric: listPlantCodeGeneric,
      };
    }
  )
);
